<div class="w-100 h-100 d-flex align-items-center justify-content-center">
  <div class="app-not-found text-center">
    <img src="assets/img/404.svg">
    <div class="mat-display-3 my-3">Ups! Nic tu nie ma</div>
    <p>Przeniesiemy Cię do strony głównej</p>
  </div>
</div>
